var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"PeekioIcon"}},[_c('a',{attrs:{"target":"_blank","href":"https://peekio.no/"}},[_c('img',{attrs:{"src":require('../../assets/img/peekio.png')}})])])}
var staticRenderFns = []

export { render, staticRenderFns }